module.exports = __webpack_public_path__ + "static/media/icon-information.90ee17a9.svg";